import { createAction, props } from '@ngrx/store';
import { Notification } from '../../models/Notification';
import e from 'express';

export const loadNotifications = createAction(
  '[Notification] Load Notifications',
  props<{ customerNo: number }>()
);

export const loadNotificationsSuccess = createAction(
  '[Notification] Load Notifications Success',
  props<{ notifications: Notification[] }>()
);

export const loadNotificationsFailure = createAction(
  '[Notification] Load Notifications Failure',
  props<{ error: any }>()
);

export const loadNotificationsForCustomer = createAction(
  '[Notification] Load Notifications For Customer'
);
export const loadNotificationsForCustomerSuccess = createAction(    
  '[Notification] Load Notifications For Customer Success',
  props<{ notifications: Notification[] }>()
);
export const loadNotificationsForCustomerFailure = createAction(
  '[Notification] Load Notifications For Customer Failure',
  props<{ error: any }>()
);

export const notify = createAction(
  '[Notification] Notify',
  props<{ message: string }>()
);

export const notifySuccess = createAction(
  '[Notification] Notify Success'
);

export const notifyFailure = createAction(
  '[Notification] Notify Failure',
  props<{ error: any }>()
);

export const markAsRead = createAction(
  '[Notification] Mark As Read',
  props<{ id: number }>()
);

export const markAsReadSuccess = createAction(
  '[Notification] Mark As Read Success',
  props<{ id: number }>()
);

export const markAsReadFailure = createAction(
  '[Notification] Mark As Read Failure',
  props<{ error: any }>()
);

export const createNotification = createAction(
  '[Notification] Create Notification',
  props<{ notification: Notification }>()
);

export const createNotificationSuccess = createAction(
  '[Notification] Create Notification Success',
  props<{ notification: Notification }>()
);

export const createNotificationFailure = createAction(
  '[Notification] Create Notification Failure',
  props<{ error: any }>()
);

export const markAllAsRead = createAction(
  '[Notification] Mark All As Read'
);

export const markAllAsReadSuccess = createAction(
  '[Notification] Mark All As Read Success'
);

export const markAllAsReadFailure = createAction(
  '[Notification] Mark All As Read Failure',
  props<{ error: any }>()
);
